import {CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem,} from '@angular/cdk/drag-drop';
import {TitleCasePipe} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {MatButton, MatIconButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {Asset, AssetService, GroupAsset} from '@app/asset';
import {AssetColorMap, AssetType, IconMap} from '@app/asset/models';
import {GroupService} from '../group.service';

@Component({
    selector: 'frog-edit-group-dialog',
    templateUrl: './edit-group-dialog.component.html',
    styleUrls: ['./edit-group-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        CdkDropList,
        CdkDrag,
        MatIcon,
        MatIconButton,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TitleCasePipe,
    ],
})
export class EditGroupDialogComponent implements OnInit {
    public AssetType = AssetType;
    public IconMap = IconMap;
    public AssetColorMap = AssetColorMap;

    constructor(
        private groupService: GroupService,
        private assetService: AssetService,
        public dialogRef: MatDialogRef<EditGroupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: GroupAsset,
    ) {}

    ngOnInit(): void {}

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.data.children, event.previousIndex, event.currentIndex);
        const child = this.data.children[event.currentIndex];
        this.groupService.insert(this.data.id, child.id, event.currentIndex).subscribe((group) => {
            this.assetService.reserializeAsset(group);
        });
    }

    remove(asset: Asset) {
        if (this.data.children.length <= 2) {
            // Just ungroup if we are removing all but one
            this.groupService.ungroup(this.data.id).subscribe((group) => {
                this.dialogRef.close();
                this.assetService.reserializeAsset(this.data);
            });
        } else {
            const index = this.data.children.indexOf(asset);
            const dummy = [];
            transferArrayItem(this.data.children, dummy, index, 0);

            this.groupService.remove(this.data.id, asset.id).subscribe((group) => {
                this.assetService.reserializeAsset(this.data);
            });
        }
    }
}
